import React, { useState } from "react";
import ToastPopup from "./ToastPopup";
import { FunctionAddAdminChecklistProps, createToastMessage, ToastMessage } from '../interFaces/interfaces';
import "../css/others/Popup.css";
const FunctionAddChecklist: React.FC<FunctionAddAdminChecklistProps> = ({ newChecklistName, newChecklistDescription, setNewChecklistName, setNewChecklistDescription, handleSaveNewChecklist, onClose }) => {
  const [message, setMessage] = useState<ToastMessage | null>(null);
  const restrictedChars = /[\\:*?"<>|/]/;
  const handleSave = () => {
    if (!newChecklistName.trim() || !newChecklistDescription.trim()) {
      setMessage(createToastMessage("Please fill all fields", "warning", 3000));
      return;
    }
    if (newChecklistName?.length > 60) {
      setMessage(createToastMessage("Function Checklist Name cannot exceed 60 characters", "warning", 3000));
      return;
    }
    handleSaveNewChecklist();
  };
  const handleRestrictedInputChange = (value: string, setter: (val: string) => void) => {
    if (restrictedChars.test(value)) {
      setMessage(createToastMessage(`Special characters are not allowed - ${restrictedChars}`, "warning", 3000));
      return;
    }
    setter(value);
  };
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <h3>Function Create Checklist</h3>
        <label>Function CheckList Name:
          <input type="text" value={newChecklistName} onChange={(e) => handleRestrictedInputChange(e.target.value, setNewChecklistName)} required />
        </label>
        <label>Function Description:
          <textarea value={newChecklistDescription} onChange={(e) => handleRestrictedInputChange(e.target.value, setNewChecklistDescription)} required />
        </label>
        <div className="buttons">
          <button className="cancelbutton" onClick={onClose}>Cancel</button>
          <button className="savebutton" onClick={handleSave}>Save</button>
        </div>
      </div>
      {message && (<ToastPopup message={message.text} type={message.type} duration={message.duration} onClose={() => setMessage(null)} />)}    </div>
  );
};
export default FunctionAddChecklist;